import React, { useState } from "react";
import Header from "../Header/Header";
import Book from "./Book/Book";
import BookForm from "./BookForm/BookForm";

const Main = () => {

  const [search, setSearch] = useState();

  return (
    <>
      <Header setSearch={setSearch}></Header>
      <main className="py-12 2xl:px-6">
        <div className="container grid xl:grid-cols-[auto_350px] 2xl:grid-cols-[auto_400px] gap-4 2xl:gap-8">
          <Book search={search}></Book>
          <BookForm></BookForm>
        </div>
      </main>
    </>
  );
};

export default Main;
